import { Component, Inject, OnDestroy } from '@angular/core';
import { DialogManagerService } from '@src/services';
// import { JobCompletitionService } from '@src/services/jobCompletitionService';
import { packagesActions } from '@src/store/reducers/packagesReducer';
import {projectsActions} from '@src/store/reducers/projectsReducer'
import { applicationActions } from '@src/store/reducers/applicationReducer';
import {applicationAlertsTypes} from '@src/store/reducers/applicationReducer';
import { AddPackageDialogComponent } from '@app/shared/components/dialogs';
//import { AuthorizationService } from '@src/services';
import { Store } from '@src/store';
import { consts } from '@src/constants/consts';
import _ from 'lodash';
import { ProcessesHoverViewComponent } from "../pipeline/processesHoverView-ang7/processesHoverView";
import { ViewChild } from "@angular/core";

@Component({
    selector: 'packageManager',
    template: require('./packageManager.html'),
    styles: [require('./_packageManager.scss')]
})
export class PackageManagerComponent implements OnDestroy {
    @ViewChild(ProcessesHoverViewComponent) childRef: ProcessesHoverViewComponent;

    public isJobInProgress:boolean = false;
    public schemas = [];
    public selectedScriptType;
    public currentItem = null;
    public selectedItem: any;
    public scriptId:any;
    public onProcessUpdateReceivedData;
    public dplModeType: any;
    public unsubscribe2:any;
    public dataT:string;
    public projectId;
    public hasExistingPackages;
    public continouesErrorCount:number;
    public packageId;
    public connectionState;
    public tempScriptList:any;
    public projectData:any;
    public projectWithMetaData;
    public scriptListTemp:any = [];
    public packScriptId;
    public m_getEnvTypes;
    public unsubscribe;
    public isChecked:boolean = false;
    public canEditPackageScripts:any;
    public connectionStatuses = {
        GOOD: "GOOD",
        WARNING: "WARNING",
        BAD: "BAD",
    };
    public selectedPackage: any;
    public $translate:any;

    constructor(
        private store: Store,
        // @Inject('$q') private $q: any
        private dialogManagerService: DialogManagerService,
        @Inject('jobCompletitionService') private jobCompletitionService: any,
        @Inject('authorizationService') private authorizationService: any,
        @Inject('$state') public state: any,
        @Inject('$scope') private $scope: any,
        @Inject('$q') private $q: any,
        @Inject('$stateParams') private $stateParams: any,
        @Inject('$filter') private $filter: any) {
            this.projectId = this.$stateParams.id;
            this.projectData = this.store.getState().project.data;
            this.$translate = this.$filter('translate');
            this.onProcessUpdateReceivedData = this.jobCompletitionService.onProcessUpdateReceivedData.bind(this);
            this.m_getEnvTypes = this.jobCompletitionService.m_getEnvTypes.bind(this)
    }                                                                                                                                                                                                              
    async ngOnInit(){
        this.$scope.$on("$destroy", () => {
            this.ngOnDestroy();
        });
        this.unsubscribe = this.store.subscribe(() => {
            this.hasExistingPackages = this.store.getState().packageManager.no_items_packages;
        })
        this.$scope.$watch(() => this.store.getState().projects.projectWithMetaData, (newVal, oldVal) => {
            if(oldVal){}
            if (newVal) {
                this.projectWithMetaData = newVal;
                this.dplModeType = this.store.getState().enums.DeployModeTypes[newVal.dplModeType];
            }
        });
        this.$q.all([
            this.store.dispatch({ type: packagesActions.GET_SCRIPTS, payload: { id: this.projectId } }),
            this.store.dispatch({ type: projectsActions.GET_PROJECT_META_DATA, payload: { projId: this.projectId } })
        ]);
    }

    UpdateEnvType = (envType, targetEnvName, execJob) => {
        envType.environments.forEach((env) => {
            if (env.name === targetEnvName) {
                env.percentageComplete = execJob.PercentageComplete;
            }
        });
    };

    connectionStateUpdate() {
        if (this.continouesErrorCount > 5) {
            this.connectionState = this.connectionStatuses.BAD;
        } else if (this.continouesErrorCount > 0) {
            this.connectionState = this.connectionStatuses.WARNING;
        } else {
            this.connectionState = this.connectionStatuses.GOOD;
        }
    }

    connectionStateReset() {
        this.continouesErrorCount = 0;
        this.connectionStateUpdate();
    }

    connectionStateAddError() {
        this.continouesErrorCount++;
        this.connectionStateUpdate();
    }

    updateJobCompletionPercentage(execJob) {
        let jobCompletionPercentage = [...this.store.getState().jobs.jobCompletionPercentage || []];
        let newJobCompletion = { jobId: execJob.JobQId, completionPercentage: execJob.PercentageComplete };
        if (jobCompletionPercentage.find(job => job.jobId == execJob.JobQId))
            return jobCompletionPercentage.map(job => job.jobId == execJob.JobQId ? newJobCompletion : job);
        return [...jobCompletionPercentage, newJobCompletion];
    }

    newPackage = async () => {
        const canAddPackages = await this.authorizationService.isAuthorizedToPerformAction(consts.userPermissions.AddVersion, this.projectId);
        if (!canAddPackages) {
            this.$scope.$apply(() => {
                this.dialogManagerService.showErrorDialog({
                    title: this.$translate("ERROR"),
                    text: `${this.$translate("ERROR_OCCURRED")} : ${this.$translate("USER_UNAUTHORIZED")}`
                });
            });
            return;
        }

        const onConfirm = (data) => {
            if (!data.packageName || data.packageName.trim().length == 0) {
                this.dialogManagerService.showErrorDialog({ title: '', text: this.$translate("ERROR_PACKAGE_NAME_EMPTY") });
            } else {
            this.store.dispatch({
                type: packagesActions.ADD_PACKAGE,
                payload: {
                    projectId: this.projectId,
                    packageName: data.packageName,
                    isAdhocPackage: data.isAdhocPackage || false
                },
                callback: (response) => {
                    if (response.data == -1) {
                        var alert = { type: applicationAlertsTypes.ERROR, text: "Invalid Version Format." };
                        this.store.dispatch({ type: applicationActions.ALERT, payload: { alert } });
                        setTimeout(() => {
                            this.store.dispatch({ type: applicationActions.CLEAR_ALERTS, payload: { alert: null } });
                        }, 4000);
                    }
                }
            });
            
            }
        };
        const dialogData = { title: 'Add New Package', packageName: this.dplModeType == "ByTask"?'' : 'V'};
        this.dialogManagerService.showDialog(dialogData, onConfirm, AddPackageDialogComponent, 'add-package-dialog');

    }

    changeScriptType(type) {
        this.selectedScriptType = type;
    }

    addToPackage(data) {
        let checkedScriptsIds = data.data.map(item => item.checked ? item.id : null);
        checkedScriptsIds = _.orderBy(checkedScriptsIds, [], ['asc']);
        if (this.packageId) {
            let promises = [];
            checkedScriptsIds.forEach(item => {
                if (item) {
                    promises.push(() => {
                        return this.store.dispatch({
                            type: packagesActions.ADD_SCRIPT_TO_PACKAGE_WITH_SCRIPT_TYPE,
                            payload: { projectId: this.projectId, packageId: this.packageId, scriptId: item, scriptType: this.selectedScriptType.data }
                        });
                    });
                }
            });
            promises.reduce((promiseChain, currentTask) => {
                return promiseChain.then(chainResults =>
                    currentTask().then(currentResult => [...chainResults, currentResult])
                );
            }, Promise.resolve([])).then(() => {
                this.store.dispatch({ type: packagesActions.GET_PACKAGES, payload: { id: this.projectId } });
                this.store.dispatch({ type: packagesActions.IMPORT_SCRIPTS, payload: { projectId: this.projectId } });
            });
        }
    }

    moveScriptType(objectMoveScript) {
        this.store.dispatch({
            type: packagesActions.CHANGE_SCRIPT_TYPE,
            payload: { projectId: this.projectId, packageId: this.packageId, scriptId: objectMoveScript.script.scriptId, scriptType: objectMoveScript.scriptType }
        }).then(() => objectMoveScript.callback());
    }

    removeScript(data) {
        let checkedScriptsIds = data.data.reduce((res, item) => {
            if (item.checked) {
                res.push(item.id)
            }
            return res;
        }, []);
        if (this.projectId) {
            if (checkedScriptsIds && checkedScriptsIds.length > 0) {
                return this.store.dispatch({
                    type: packagesActions.DELETE_SCRIPT_LIST_WITHOUT_PACAKGE,
                    payload: { projectId: this.projectId, scriptsIds: checkedScriptsIds }
                });
            }
        }
    }

    onSelectedScript(obj) {
        //console.log(obj)
        this.scriptId = obj.script.id;
    }

    onSelectedPackage(data) {
        if (data)
            this.packageId = data.data.id;
    }

    onSelectPackScript(obj) {
        //console.log(obj)
        this.packScriptId = obj.script.ScriptId;
    }
   
    ngOnDestroy = function () {
        if (this.childRef) {
            this.childRef.ngOnDestroy();
        }
        this.unsubscribe();
        this.store.dispatch({ type: packagesActions.RESET_STATE });
    };

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/project/packageManager/packageManager-ang7.ts